import React from "react";
import { useNavigate, createSearchParams } from "react-router-dom";
import {
  Container,
  Row,
  Title,
  StatusBadge,
  Meta,
  MetaItem,
  Divider,
  Actions,
  Button,
  GhostBtn,
} from "./styles";
import { instanceAPI } from "api";
import { useTaskStore } from "store/task";
import { useConfirmStore } from "modal/confirm/store";

const PowerIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <line x1="12" y1="3" x2="12" y2="9" />
    <path d="M5.5 7.5a8 8 0 1 0 13 0" />
  </svg>
);

const Card = ({ data }) => {
  const navigate = useNavigate();
  const { addTask } = useTaskStore();
  const { openConfirm } = useConfirmStore();

  const isOn = data.power === "ON";
  const accent =
    data.session === "connect" ? "emerald" : isOn ? "indigo" : "zinc";

  const handlePowerClick = () => {
    openConfirm({
      title: isOn ? "전원을 재시작하시겠습니까?" : "전원을 키겠습니까?",
      desc: isOn ? "전원을 재시작합니다." : "VDI 전원을 켭니다.",
      onConfirm: async () => {
        const res = await instanceAPI.power(data.name, isOn ? "restart" : "on");
        addTask({
          name: data.name,
          id: res.data.task_id,
          job: `VDI Power : ${isOn ? "restart" : "on"}`,
          state: "pending",
        });
      },
    });
  };

  return (
    <Container $accent={accent}>
      <Row>
        <Title>{data.name}</Title>
        <StatusBadge $on={data.session === "connect"}>
          {data.session === "connect" ? "Connect" : "Disconnect"}
        </StatusBadge>
      </Row>

      <Meta>
        <MetaItem>
          <span className="label">Owner</span>
          <span className="value">{data.owner ?? "—"}</span>
        </MetaItem>

        <MetaItem>
          <span className="label">Login</span>
          <span className="value">{data.login ?? "—"}</span>
        </MetaItem>

        <MetaItem>
          <span className="label">Internet</span>
          <span className="value">{data.internet ? "ON" : "OFF"}</span>
        </MetaItem>
        <MetaItem>
          <span className="label">Network</span>
          <span className="value">{data.network ?? "—"}</span>
        </MetaItem>
      </Meta>

      <Divider />

      <Actions>
        <GhostBtn
          onClick={() =>
            navigate({
              pathname: "/metric",
              search: `?${createSearchParams({ name: data.name })}`,
            })
          }
        >
          Info
        </GhostBtn>

        <Button $variant={isOn ? "restart" : "on"} onClick={handlePowerClick}>
          <PowerIcon />
          {isOn ? "Restart" : "On"}
        </Button>
      </Actions>
    </Container>
  );
};

export default Card;
